import { h } from '@stencil/core';

export let loopInitiMethods = ($this: any) => {
  $this.numLoopItems = $this.numItems + 2 * $this.eachSideClone;
  $this.currentIndex = $this.eachSideClone;
};

export const generateRandomId = () => {
  const crypto = window.crypto;
  const array = new Uint32Array(1);
  const uniqueNumArr = crypto.getRandomValues(array);
  return uniqueNumArr[0];
};

export const renderCarouselItems = ($this): [] => {
  let baseCount = 4;
  let prevClonedData = [];
  let originalData = [];
  let nextClonedData = [];
  let current = 0;
  const totalItems = $this.carouselData['child'].length;

  // Helper function to wrap indices within bounds
  const wrapIndex = (index) => {
    // Ensure index is always in range [0, totalItems-1]
    return ((index % totalItems) + totalItems) % totalItems;
  };

  if ($this.loop) {
    [...Array(baseCount)].forEach((_, liCount) => {
      // Wrap index for previous cloned items
      current = wrapIndex(totalItems - baseCount + liCount);
      prevClonedData.push(
        <li key={current} data-cloned role="listitem" aria-roledescription="slide" aria-setsize={$this.numItems} tabindex="-1" aria-hidden="true"
          onFocus={() => handleListFocus($this)}
          onMouseEnter={() => decelerate($this, true)}
          onMouseLeave={() => decelerate($this, false)}>
          {getCarouselItemContent(current, '', $this)}
        </li>,
      );

      // Wrap index for next cloned items
      current = wrapIndex(liCount);
      nextClonedData.push(
        <li key={current} data-cloned role="listitem" aria-roledescription="slide" aria-setsize={$this.numItems} tabindex="-1" aria-hidden="true"
          onFocus={() => handleListFocus($this)}
          onMouseEnter={() => decelerate($this, true)}
          onMouseLeave={() => decelerate($this, false)}>
          {getCarouselItemContent(current, '', $this)}
        </li>,
      );
    });
  }

  let headerIds = [];

  $this.carouselData['child'].forEach(() => {
    headerIds.push(generateRandomId().toString());
  });

  [...Array($this.numItems)].forEach((_, bundle) => {
    // Ensure bundle index is within bounds
    const safeIndex = wrapIndex(bundle);
    current = $this.numItems + bundle;
    originalData.push(
      <li
        key={current}
        role="listitem"
        aria-roledescription="slide"
        aria-setsize={$this.numItems}
        aria-posinset={bundle + 1}
        tabindex="-1"
        aria-hidden="true"
        onFocus={() => handleListFocus($this)}
        onMouseEnter={() => decelerate($this, true)}
        onMouseLeave={() => decelerate($this, false)}
      >
        {getCarouselItemContent(safeIndex, headerIds[safeIndex], $this)}
      </li>,
    );
  });

  const childItems: any = [...prevClonedData, ...originalData, ...nextClonedData];

  return childItems;
};

export const getCarouselItemContent = (itemNumber: number, headerId: string, $this) => {
  switch ($this.childType) {
    case 'CBundle':
      return renderCBundle(itemNumber, headerId, $this);
    case 'OfferBundle':
      return renderOfferBundle(itemNumber, headerId, $this);
    case 'SIBundle':
      break;
    case 'ect':
      return renderECT(itemNumber, headerId, $this);
case 'sct':
  return renderSCT(itemNumber, $this);
    case 'iconBundle':
      return renderIconBundle(itemNumber,headerId, $this);
  }
};

export const renderCBundle = (itemIndex: number, headerId: string, $this) => {
  return (
    <vs-content-bundle
      contentBundleData={$this.carouselData['child'][itemIndex]}
      layout={$this.layout}
      display-publish-date={$this.displayCBundleDate}
      play-aria-label={$this.carouselData['ariaLabelPlayVideo']}
      header-id={headerId}
    ></vs-content-bundle>
  );
};

export const renderOfferBundle = (itemIndex: number, headerId: string, $this) => {
  return (
    <vs-offer-bundle
      offerBundleData={$this.carouselData['child'][itemIndex]}
      layout={$this.layout}
      header-id={headerId}
    ></vs-offer-bundle>
  );
};

export const renderECT = (itemIndex: number, headerId: string, $this) => {

  return (
      <vs-ect
        contentBundleData={$this.carouselData['child'][itemIndex]}
        layout={$this.layout}
        display-publish-date={$this.displayECTDate}
        header-id={headerId}
        rank-in-container={itemIndex}
      ></vs-ect>
  );
}

export const renderSCT = (itemIndex: number, $this) => {
  const sctData = $this.carouselData['child'][itemIndex];
  return (
    <vs-sct
      eyebrow={sctData.eyebrow}
      desktopImagePath={sctData.desktopImagePath}
      alt={sctData.desktopAltText}
      disableLazyLoading={sctData.disableLazyLoading}
      header={sctData.ctas && sctData.ctas.length > 0 ? sctData.ctas[0].ctaTitle : ''}
      cta={sctData.ctas} // Pass cta data to vs-simple-content-tile
      gradientOverlay={sctData.gradientOverlay}
      uniqueId={sctData.uniqueId}
      layout={$this.layout}
    ></vs-sct>
  );
};

export const renderIconBundle = (itemIndex: number,headerId: string, $this) => {
  const iconData = $this.carouselData['child'][itemIndex];
  return (
    <vs-icon-bundle
      iconbundleid={iconData.id}
      image-reference={iconData.imageReference}
      alignment="true"
      alt-text={iconData.altText}
      title={iconData.title}
      header-style={iconData.headerStyle}
      description={iconData.description}
      is-migrated={iconData.isMigrated}
      should-wrap-description-in-p-tags={iconData.shouldWrapDescriptionInPTags}
      cta={JSON.stringify(iconData.ctas)}
      layout={$this.layout}
      headerId={headerId}
    ></vs-icon-bundle>
  );
};

export let scrollBarBehaviourOnInput = (e, $this) => {
  let val = e.target.value;
  $this.swiped = val * -$this.docDirFactor;
};

export let scrollBarBehaviourOnChange = (e, $this) => {
  let curVal = e.target.value * -$this.docDirFactor;
  let closestDiff = 0;
  closestDiff = $this.scrollVals.reduce((a, b) => {
    return Math.abs(b - curVal) < Math.abs(a - curVal) ? b : a;
  });
  $this.scrollState = closestDiff;
  $this.swiped = $this.scrollState;
  handleAccessibility($this);
};

export let getLiWidth = ($this): number => {
  let widthVal = 0;
    if ($this.screenWidth < 768) {
      if ($this.carouselData['componentType'] === "ect") {
        return 280;
      }
      widthVal = 0.75 * $this.screenWidth;
    } else if ($this.screenWidth < 992) {
      if ($this.carouselData['componentType'] === "OfferBundle") {
        return 0.5 * 729;
      }else if ($this.carouselData['componentType'] === "ect") {
        widthVal = ($this.screenWidth * (10 / 12)) / 2;
      }
      widthVal = 0.6 * $this.screenWidth;
    } else if ($this.screenWidth < 1200) {
      if ($this.carouselData['componentType'] === "OfferBundle") {
        return $this.layoutFactor * 942;
      }
      widthVal = ($this.screenWidth * (10 / 12)) / 2;
    } else {
      widthVal = $this.layoutFactor * 1140;

  }

  return widthVal;
};

export let setLeftPaddleAriaLabel = $this => {
  return $this.docDir === 'ltr' ? $this.carouselData['ariaLabelPreviousSlide'] : $this.carouselData['ariaLabelNextSlide'];
};

export let setRightPaddleAriaLabel = $this => {
  return $this.docDir === 'ltr' ? $this.carouselData['ariaLabelNextSlide'] : $this.carouselData['ariaLabelPreviousSlide'];
};

export let showNavButtons = $this => {
  if ($this.loop || Math.abs($this.scrollState) < Math.abs($this.scrollableWidth)) {
    showButton($this.nextButton);
  } else {
    hideButton($this.nextButton);
  }
  if ($this.loop || Math.abs($this.scrollState) > 0) {
    showButton($this.prevButton);
  } else {
    hideButton($this.prevButton);
  }
};

export let hideNavButtons = $this => {
  hideButton($this.prevButton);
  hideButton($this.nextButton);
};

export let handleLeftClick = $this => {
  if ($this.docDir === 'ltr') {
    handlePrevSlide($this);
  } else {
    handleNextSlide($this);
  }
};

export let handleRightClick = $this => {
  if ($this.docDir === 'ltr') {
    handleNextSlide($this);
  } else {
    handlePrevSlide($this);
  }
};

export let handlePrevSlide = $this => {
  if ($this.isTransitionStarted) {
    return;
  }
  if (!$this.loop) {
    if ($this.currentIndex > 0) {
      $this.currentIndex -= 1;
      $this.scrollState = $this.scrollVals[$this.currentIndex];
      $this.swiped = $this.scrollState;
      if ($this.swiped === 0 && $this.currentIndex === 0) {
        hideButton($this.prevButton);
      }
    } else {
      hideButton($this.prevButton);
    }
  } else {
    handlePrevSlideLoop($this);
  }
  handleAccessibility($this);
};

export let handlePrevSlideLoop = $this => {
  if ($this.currentIndex >= $this.eachSideClone) {
    const items = [...Array.from($this.allListItems)];
    $this.currentIndex -= 1;
    const elem: any = items[$this.currentIndex];
    const isPrevElemCloned = elem.hasAttribute('data-cloned');
    $this.scrollState = $this.scrollVals[$this.currentIndex];
    if (isPrevElemCloned) {
      $this.isClonedPrev = true;
    }
    $this.swiped = $this.scrollState;
  }
};

export let handleNextSlide = $this => {
  if ($this.isTransitionStarted) {
    return;
  }
  if (!$this.loop) {
    if ($this.currentIndex < $this.numItems - 1) {
      $this.currentIndex += 1;
      $this.scrollState = $this.scrollVals[$this.currentIndex];
      $this.swiped = $this.scrollState;
      if (Math.floor($this.swiped) === $this.scrollableWidth) {
        $this.nextButton.blur();
        hideButton($this.nextButton);
      }
    }
  } else {
    handleNextSlideLoop($this);
  }
  handleAccessibility($this);
};

export let handleNextSlideLoop = $this => {
  if ($this.currentIndex <= $this.numItems + $this.eachSideClone - 1) {
    const items = [...Array.from($this.allListItems)];
    $this.currentIndex += 1; // Fixed redundant assignment
    const elem: any = items[$this.currentIndex];
    const isNextElemCloned = elem.hasAttribute('data-cloned');
    $this.scrollState = $this.scrollVals[$this.currentIndex]; // Add this line for consistency
    if (isNextElemCloned) {
      $this.isClonedNext = true;
    }
    $this.swiped = $this.scrollState;
  }
};

export const handleLoopOver = $this => {
  const prevListItem = $this.allListItems[$this.currentIndex];
  unSetListItemAccesibility(prevListItem)
  if ($this.currentIndex === $this.eachSideClone + $this.numItems) {
    $this.currentIndex = $this.eachSideClone;
  } else {
    $this.currentIndex = $this.numItems + $this.eachSideClone - 1;
  }
  const currentActiveLi = $this.allListItems[$this.currentIndex];
  setListItemAccesibility(currentActiveLi);
  $this.scrollState = $this.scrollVals[$this.currentIndex];
  $this.carouselList.style.transition = `none`;
  $this.swiped = $this.scrollState;
  setTimeout(() => {
    $this.carouselList.style.transition = `transform 200ms ease`;
  }, 100);
};

export const showButton = (btn: any) => {
  btn.classList.remove('vs-d-none');
  btn.classList.add('vs-d-block');
};

export const hideButton = (btn: any) => {
  btn.classList.remove('vs-d-block');
  btn.classList.add('vs-d-none');
};

export let unSetListItemAccesibility = (listItem: any) => {
  unSetTabIndex(listItem);
  setAriaHidden(listItem);
};

export let setListItemAccesibility = (listItem: any) => {
  setTabIndex(listItem);
  unSetAriaHidden(listItem);
};

export let setTabIndex = (item: any) => {
  item.setAttribute('tabindex', '0');
};

export let unSetTabIndex = (item: any) => {
  item.setAttribute('tabindex', '-1');
};

export let setAriaHidden = (item: any) => {
  item.setAttribute('aria-hidden', 'true');
};

export let unSetAriaHidden = (item: any) => {
  item.setAttribute('aria-hidden', 'false');
};

export let hideAccessibleItems = (listItem: any) => {
  let allAnchors = [...listItem.getElementsByTagName('a')];
  let allButtons = [...listItem.getElementsByTagName('button')];

  allAnchors.forEach(anc => {
    unSetTabIndex(anc);
  });

  allButtons.forEach(btn => {
    unSetTabIndex(btn);
  });
};

export let showAccessibleItems = (listItem: any) => {
  let allAnchors = [...listItem.getElementsByTagName('a')];
  let allButtons = [...listItem.getElementsByTagName('button')];

  allAnchors.forEach(anc => {
    setTabIndex(anc);
  });

  allButtons.forEach(btn => {
    setTabIndex(btn);
  });
};

export let setInitialAccessibility = $this => {
  [...$this.allListItems].forEach(li => {
    hideAccessibleItems(li);
  });
};

export let handleAccessibility = $this => {
  let currentActiveLi = $this.allListItems[$this.currentIndex];
  const liBeforeCurrent = [...$this.allListItems].slice(0, $this.currentIndex);
  const liAfterCurrent = [...$this.allListItems].slice($this.currentIndex + 1, $this.allListItems.length);
  makeLiUnaccessible(liBeforeCurrent);
  makeLiUnaccessible(liAfterCurrent);
  setListItemAccesibility(currentActiveLi);
  showAccessibleItems(currentActiveLi);
};

export let makeLiUnaccessible = (list: any) => {
  list.forEach(liElement => {
    unSetListItemAccesibility(liElement);
    hideAccessibleItems(liElement);
  });
};

export let addListItemFocusOutline = (listItem: any) => {
  // Check if the focused element is a child of the list item (e.g., vs-bundle-cta link)
  const activeElement = document.activeElement;
  if (listItem.contains(activeElement) && activeElement.matches('.vs-bundle-cta-item a')) {
    return; // Skip adding the vs-tab-focused class
  }

  // Remove vs-tab-focused from siblings
  [...listItem.parentElement.children].forEach(sibling => {
    if (sibling !== listItem) {
      sibling.classList.remove('vs-tab-focused');
    }
  });

  // Add the vs-tab-focused class to the current list item
  listItem.classList.add('vs-tab-focused');
};

export let removeListItemFocusOutline = (listItem: any) => {
  listItem.classList.remove('vs-tab-focused');
};

export let handleOriginalEdgeAccessibility = (currentLi: any, $this) => {
  if ($this.currentIndex === $this.numItems + $this.eachSideClone) {
    currentLi = $this.allListItems[$this.eachSideClone];
  } else if ($this.currentIndex === $this.eachSideClone - 1) {
    currentLi = $this.allListItems[$this.eachSideClone + $this.numItems - 1];
  }
  addListItemFocusOutline(currentLi);
};

export let handleTabPressed = (currentLi: any, $this) => {
  $this.allListItems[$this.currentIndex].scrollIntoView();
  addListItemFocusOutline(currentLi);
  handleAccessibility($this);
};

export let handleLefRightKeyPresses = (currentActive: any, currentLi: any, event, $this) => {
  removeListItemFocusOutline(currentLi);
  unSetListItemAccesibility(currentLi);
  unSetTabIndex(currentActive);

  if (event.keyCode === 37) {
    $this.handleLeftPaddleClick();
  } else if (event.keyCode === 39) {
    $this.handleRightPaddleClick();
  }
  currentLi = $this.allListItems[$this.currentIndex];

  if (currentLi.hasAttribute('data-cloned')) {
    handleOriginalEdgeAccessibility(currentLi, $this);
    // Add these lines to ensure screen reader announces cloned elements
    handleAccessibility($this);
    currentLi.focus();
  } else {
    if (!$this.paddlePressed) {
      handleAccessibility($this);
    }
    currentLi.focus();
    addListItemFocusOutline(currentLi);
  }
};

export let handleKeyPresses = (event, $this) => {
  let currentActive = document.activeElement;
  let currentLi = $this.allListItems[$this.currentIndex];
  removeListItemFocusOutline(currentLi);
  if (event.keyCode === 37 || event.keyCode === 39) {
    handleLefRightKeyPresses(currentActive, currentLi, event, $this);
  } else if (event.keyCode === 9) {
    handleTabPressed(currentLi, $this);
  }
};

export let handleAutoScrollEnd = $this => {
  // find next scrollIndex
  let closestDiff = 0;
  closestDiff = $this.scrollVals.reduce((a, b) => {
    return Math.abs(b - $this.swiped) < Math.abs(a - $this.swiped) ? b : a;
  });
  $this.scrollState = closestDiff;
  $this.swiped = $this.scrollState;
  // set index
  $this.currentIndex = $this.scrollVals.indexOf($this.scrollState);

  handleAccessibility($this);
}

//can be reused
export let setSnapValues = $this => {
  if ($this.childType === 'OfferBundle') {
    setOfferSnapValues($this);
    return;
  }
  let snapFactor = $this.docDir === 'rtl' ? -1 : 1;
  $this.scrollVals = [];
  let lastEntireSlidesVisible = 1;
  let scrollToSecondSlide = 0;
  let scrollToLastSlides = ($this.carouselWidth - $this.screenWidth) * snapFactor;
  let extraVal = 0;
  $this.scrollableWidth = scrollToLastSlides * snapFactor;
  if ($this.screenWidth < 768) {
    scrollToSecondSlide = 0.625 * $this.screenWidth * snapFactor;
  } else if ($this.screenWidth < 992) {
    scrollToSecondSlide = 0.4 * $this.screenWidth * snapFactor;
  } else if ($this.screenWidth < 1200) {
    scrollToSecondSlide = 0.125 * $this.screenWidth * snapFactor;
  } else {
    scrollToSecondSlide = $this.typicalSlideWidth * snapFactor;
    lastEntireSlidesVisible = $this.layout === '2up' ? 2 : 3;
  }
  $this.scrollVals.push(0);
  $this.scrollVals.push(-scrollToSecondSlide);
  let furtherScrolls = scrollToSecondSlide;

  if ($this.loop) {
    for (let current = 2; current < $this.numLoopItems; current += 1) {
      furtherScrolls += $this.typicalSlideWidth * snapFactor;
      $this.scrollVals.push(-furtherScrolls);
    }
  } else {
    for (let current = 2; current < $this.numItems - lastEntireSlidesVisible; current += 1) {
      furtherScrolls += $this.typicalSlideWidth * snapFactor;
      $this.scrollVals.push(-furtherScrolls);
    }
    for (let current = $this.numItems - lastEntireSlidesVisible; current < $this.numItems; current += 1) {
      $this.scrollVals.push(-scrollToLastSlides);
    }
    extraVal = (scrollToLastSlides + scrollToSecondSlide) * snapFactor;
    $this.scrollVals.push(-extraVal); // extra for handling last
  }
};

export let setOfferSnapValues = $this => {
  let snapFactor = $this.docDir === 'rtl' ? -1 : 1;
  $this.scrollVals = [];
  let scrollToSecondSlide = 0;
  let scrollToLastSlides = ($this.carouselWidth - $this.screenWidth) * snapFactor;
  $this.scrollableWidth = scrollToLastSlides * snapFactor < 0 ? 0 : scrollToLastSlides * snapFactor;
  let furtherScrolls = scrollToSecondSlide;
  $this.scrollVals.push(0);
  if ($this.loop) {
    for (let current = 1; current < $this.numLoopItems; current += 1) {
      furtherScrolls += $this.typicalSlideWidth * snapFactor;
      $this.scrollVals.push(-furtherScrolls);
    }
  } else {
    for (let current = 1; current < $this.numItems; current += 1) {
      furtherScrolls += $this.typicalSlideWidth * snapFactor;
      $this.scrollVals.push(-furtherScrolls);
    }
  }
};

export let handleListFocus = ($this) => {
  if (!$this.tabPaused && $this.autoPlay) {
    $this.tabPaused = true;
    $this.toggleAutoScroll();
  }
}

export function renderDesktopItems($this) {
  return (
    <div class="vs-carousel-container">
    <div class={`${$this.backgroundColor} vs-pb-3 vs-container-fluid vs-px-0 vs-carousel-container-desktop-2up-2tiles-3up-3tiles vs-pt-3`}>
      <ul class="vs-carousel-desktop-list vs-col-12">
        {[...Array($this.numItems)].map((_, index) => (
          <li class={$this.layout === '3up' ? 'vs-col-4' : 'vs-col-6'}
            key={`desktop-item-${index}`}
            role="listitem"
            aria-roledescription="slide"
            aria-setsize={$this.numItems}
            aria-posinset={index + 1} 
            tabindex={$this.childType === 'sct' ? undefined : '0'} 
            aria-hidden="false"
          >
            {getCarouselItemContent(index, generateRandomId().toString(), $this)}
          </li>
        ))}
      </ul>
    </div>
    </div>
  );
}

export let decelerate = ($this, slowDown) => {
  if($this.decelerateAutoScroll){
    $this.autoScrollSpeed = slowDown ? $this.decelerateSpeed : 1;
  }
}
